export default __webpack_public_path__ + "static/media/business.0a42d8f5.png";